import axios from "../helper/axios";
import { create } from "zustand";

const useNuJobsStore = create((set) => ({
    openJds: [],
    similaryJdStats: [],

    getOSAllJds: async (body) => {
        try {
            console.log(body);
            const response = await axios.post(
                `osGetAllJds`,body
            );
            set({ openJds: response.data.data });
            set({ similaryJdStats: response.data.similarjds });
            console.log(response.data.name);
            console.log(response.data.data);
            console.log(response.data.similarjds);
        } catch (error) {
            console.log(error);
        }
    },
    getOSFilteredJds: async () => {
        try {
            const response = await axios.post(
                `osGetAllJds`
            );
            set({ openJds: response.data.data });
            set({ similaryJdStats: response.data.similarjds });
            console.log(response.data.name);
            console.log(response.data.data);
            console.log(response.data.similarjds);
        } catch (error) {
            console.log(error);
        }
    },


    clearOSJD: () => {
        console.log("clearJD");
        set({ openJds: null });
        set({ similaryJdStats: null });
    }
}));

export default useNuJobsStore;
